import type { CartUpdateAction } from '~~/types/commercetools';

const ALLOWED_FROZEN_CART_CHECKOUT_KEYS = [
  'setShippingAddress',
  'setBillingAddress',
  'setCustomerEmail',
  'setBillingAddressCustomType',
  'setShippingAddressCustomType',
] as const;

type AllowedFrozenCartCheckoutKey = typeof ALLOWED_FROZEN_CART_CHECKOUT_KEYS[number];

const isAllowedFrozenCartCheckoutKey = (key: string): key is AllowedFrozenCartCheckoutKey =>
  ALLOWED_FROZEN_CART_CHECKOUT_KEYS.includes(key as AllowedFrozenCartCheckoutKey);

export const isForbiddenCartUpdateAction = (action: CartUpdateAction): boolean => {

  const actionKeys = Object.keys(action);

  if (actionKeys.length === 0) {

    return true;

  }

  return actionKeys.some((key) => !isAllowedFrozenCartCheckoutKey(key));

};
